import FalconCloseButton from "components/common/FalconCloseButton";
import Lottie from "lottie-react";
import animationData from "../../../components/wizard/lottie/warning-light.json";
import { Modal } from "react-bootstrap";
const EmptyClaimSubmitModal = ({ show, onClose, title, description }) => {
  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="wizard-modal">
      <Modal.Body className="text-center px-4">
        <FalconCloseButton
          size="sm"
          className="position-absolute  top-0 end-0 me-2 mt-2"
          onClick={onClose}
        />

        <Lottie
          animationData={animationData}
          loop
          style={{ width: 120, height: 120, margin: "0 auto" }}
        />

        <h5 className="mt-3 text-danger fw-bold">{title}</h5>
        <div className="text-muted fs-10 mt-2">{description}</div>
      </Modal.Body>
    </Modal>
  );
};

export default EmptyClaimSubmitModal;
